/**Usage:
 *   import { toast } from "components/Toast";
 *   toast.success("Saved!");
 *   toast.error("Something went wrong", { description: "Check your connection." });
 *   const id = toast.loading("Uploading…");
 *   toast.update(id, "success", "Done!");
 *   toast.dismiss(id);
 */

import { busAdd, busDismiss, busUpdate } from "./toastBus.ts";
import type { ToastOptions, ToastType } from "./types.ts";

export const toast = {
  success: (message: string, options?: ToastOptions) =>
    busAdd("success", message, options),

  error: (message: string, options?: ToastOptions) =>
    busAdd("error", message, options),

  warning: (message: string, options?: ToastOptions) =>
    busAdd("warning", message, options),

  /** Alias for react-toastify compat */
  warn: (message: string, options?: ToastOptions) =>
    busAdd("warning", message, options),

  info: (message: string, options?: ToastOptions) =>
    busAdd("info", message, options),

  loading: (message: string, options?: ToastOptions) =>
    busAdd("loading", message, options),

  dismiss: (id?: string) => busDismiss(id),

  update: (id: string, type: ToastType, message: string, options?: ToastOptions) =>
    busUpdate(id, type, message, options),
};
